import {
  Box,
  List,
  ListItemButton,
  ListItemText,
  Tooltip,
  useTheme,
} from "@mui/material";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import React from "react";
import { Page } from "powerbi-client";
import { usePowerBiReportPagesMenu } from "../hooks/usePowerBiReportPagesMenu";

export default function PowerBiReportPagesMenu({
  reportPages,
  collapsed,
}: {
  reportPages: Page[];
  collapsed: boolean;
}) {
  const { currentActivePage, handlePageClick } = usePowerBiReportPagesMenu();
  const theme = useTheme();

  return (
    <Box>
      <List component="div" disablePadding>
        {reportPages?.map((page) => {
          const isActiveReport = currentActivePage?.name === page.name;
          return (
            <ListItemButton
              key={page.name}
              sx={[
                !collapsed
                  ? { pl: 6, justifyContent: "center" }
                  : { justifyContent: "center" },
                isActiveReport && { backgroundColor: theme.palette.action.hover },
              ]}
              onClick={
                !isActiveReport ? () => handlePageClick(page) : undefined
              }
            >
              {!collapsed ? (
                <ListItemText
                  primary={page.displayName}
                  slotProps={{
                    primary: { variant: "body2" }
                  }}
                />
              ) : (
                <Tooltip title={page.displayName} placement="right-start">
                  <ArrowRightIcon fontSize="small" />
                </Tooltip>
              )}
            </ListItemButton>
          );
        })}
      </List>
    </Box>
  );
}
